import type { Lead } from './types'

// A customer's replies to the quote they were emailed (0055), oldest first; nothing for a list that does not read.
export interface QuoteReply { at: string; email: string; name: string; subject: string; body: string }
export function quoteReplies(l: Pick<Lead, 'quote_replies'>): QuoteReply[] {
  try {
    const list: unknown = JSON.parse(l.quote_replies ?? '[]')
    return Array.isArray(list) ? list.filter((r): r is QuoteReply => !!r && typeof r === 'object' && typeof (r as QuoteReply).body === 'string' && typeof (r as QuoteReply).at === 'string') : []
  } catch { return [] }
}
